import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './fonts/Summer-Faith.otf';
import './fonts/Montserrat-Regular.otf';
import './fonts/Summer Faith.ttf';
import './fonts/Helvetica.ttf';
import './fonts/HelveticaNeue.otf';

import ScrollToTop from './components/common/ScrollToTop';
import ScrollUpButton from './components/common/ScrollUpButton';

import HeaderNavContact from './components/nav/contact';
import HeaderNavProjects from './components/nav/projects';

import DetailProjectOne from './components/nav/detailsproject/projectone/index';
import DetailProjectTwo from './components/nav/detailsproject/projecttwo/index';
import DetailProjectThree from './components/nav/detailsproject/projectthree/index';
import DetailProjectFour from './components/nav/detailsproject/projectfour/index';
import DetailProjectFive from './components/nav/detailsproject/projectfive/index';
import DetailProjectSix from './components/nav/detailsproject/projectsix/index';
import DetailProjectSeven from './components/nav/detailsproject/projectseven/index';
import DetailProjectEight from './components/nav/detailsproject/projecteight/index';
import DetailProjectNine from './components/nav/detailsproject/projectnine/index';
import DetailProjectTen from './components/nav/detailsproject/projectten/index';

import PageOne from './components/views/pageone';
import PageTwo from './components/views/pagetwo';
import PageThree from './components/views/pagethree';
import Loading from './components/views/loading';
import Animacion from './components/views/animacionhome';

const root = createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ScrollToTop />
        <ScrollUpButton />
        <Routes>
            <Route path='/' element={<App name="home" />} />
            <Route path='/servicios' element={<App name="servicios" />} />
            <Route path='/contact' element={<HeaderNavContact />} />
            <Route path='/projects' element={<HeaderNavProjects name='home' />} />
            <Route path='/projects/one' element={<HeaderNavProjects name='one' />} />
            <Route path='/projects/two' element={<HeaderNavProjects name='two' />} />
            <Route path='/projects/three' element={<HeaderNavProjects name='three' />} />
            <Route path='/detailone' element={<DetailProjectOne />} />
            <Route path='/detailtwo' element={<DetailProjectTwo />} />
            <Route path='/detailthree' element={<DetailProjectThree />} />
            <Route path='/detailfour' element={<DetailProjectFour />} />
            <Route path='/detailfive' element={<DetailProjectFive />} />
            <Route path='/detailsix' element={<DetailProjectSix />} />
            <Route path='/detailseven' element={<DetailProjectSeven />} />
            <Route path='/detaileight' element={<DetailProjectEight />} />
            <Route path='/detailnine' element={<DetailProjectNine />} />
            <Route path='/detailten' element={<DetailProjectTen />} />

            <Route path='/pageone' element={<PageOne />} />
            <Route path='/pagetwo' element={<PageTwo />} />
            <Route path='/pagethree' element={<PageThree />} />
            <Route path='/carrusel' element={<Loading />} />
            <Route path='/new' element={<Animacion />} />
        </Routes>
    </BrowserRouter>
);

reportWebVitals();
